module.exports = __webpack_public_path__ + "static/img/2025年历-4.59cfb7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025年历-4.png
// module id = 1bPh
// module chunks = 3